import React from 'react'
import Dropzone from 'react-dropzone'
import moment from 'moment'
import styles from './uploader.scss'
import bar from './bar.scss'
import { DS_MODULE_CLIENT_CONTRACT } from 'state/constants'
import MifidButton from '../DSDocuments/mifidButton'
import cs from 'classnames'
import AreYouSureDialog from './../office/areYouSureModal'
import nesProp from 'nested-property'
import uuidv4 from 'uuid/v4'

import {
	addFiles, changeFileDate, removeFile, initAdditionalUpload, hideUploadModal, uploadFiles, allocateFiles,
	updateCommentOnFileUpload, cancelUpload, goToFileForm, goBackToUploadType, fetchUploadTarifications,
	unAllocateFile
} from 'state/actions'

import i18n from 'lib/i18n'
import TarificationSelectionModal from './tarificationSelectionModal'
import SelectWrapper from '../shared/select/SelectWrap'
const _ = i18n('uploader')

// let fileId = 1
let currentFiles = {}

const FileIcon = ({ file }) => {
	if (file.name) {
		const { type } = file
		if (type === 'pdf' || type === 'x-download' || type === 'download' || (file.origin && file.origin === 'DS_ORIGIN_ORACLE')) {
			return <img src={require("resources/pdfIcon.svg")} />
		}

		return <img src={require("resources/imgIcon.svg")} />
		// the preview solution by URL.createObjectURL(file) is insecure, an rejected by Chrome in year 2023.
		// return <img src={file.preview}/>
	}
	return (
		<a href={`/data/document?id=${file.documentId}`} target="_blank" rel="noopener noreferrer">
			<img src={require("resources/pdfIcon.svg")} />
		</a>
	)
}
FileIcon.propTypes = {
	file: React.PropTypes.object.isRequired,
}

const FileProgress = ({ file }) => {
	if (file.done) {
		return <img src={require('resources/icn-checkmark.svg')} />
	}
	if (file.error) {
		return (
			<div className={styles.errorContainer}>
				<img src={require('resources/error.svg')} />
				<span>{file.error}</span>
			</div>
		)
	}
	if (file.progress === 1) {
		return (
			<div className={bar.barBg}>
				<div className={`${bar.bar} ${bar.gradient}`}>
					<div className={bar.barFill}></div>
				</div>
			</div>
		)
	}
	return (
		<div className={styles.progressBar}>
			<span style={{ width: ((file.progress * 100) + "%") }} />
		</div>
	)
}
FileProgress.propTypes = {
	file: React.PropTypes.object.isRequired,
}

export default class UploaderModal extends React.Component {
	static propTypes = {
		id: React.PropTypes.string,
		type: React.PropTypes.string.isRequired,
		step: React.PropTypes.number.isRequired,
		uploadInfo: React.PropTypes.array,
		uploadId: React.PropTypes.string,
		groupId: React.PropTypes.string,
		comment: React.PropTypes.string,
		error: React.PropTypes.bool,
		done: React.PropTypes.bool,
		dispatch: React.PropTypes.any,
		onSelectDocuments: React.PropTypes.func,
		disableUploadToOracle: React.PropTypes.bool,
		unallocatedFiles: React.PropTypes.array,
		claimWizardDocType: React.PropTypes.string,
		isUnfinishedClaim: React.PropTypes.bool,
	}

	constructor(props) {
		super(props)
		//handle groupTypeOptions when refreshing the page
		const groupTypeOptions = []
		let actGroup = []
		let groupType = ""
		if (props && props.groupId && props.uploadInfo) {
			if (props.groupId) {
				actGroup = props.uploadInfo.filter((item) => (item.id === props.groupId))[0]
			}

			if (actGroup) {
				for (const oneFileType of actGroup.fileTypes) {
					if (oneFileType.max && oneFileType.max > 0 && (!oneFileType.files || oneFileType.files.length < oneFileType.max)) {
						groupTypeOptions.push({
							label: oneFileType.title[global.lang],
							value: oneFileType.id
						})
					}
				}
			}
		}

		if(props.type === 'claim' && props.claimWizardDocType) {
			groupType= '1'
		}

		this.state = {
			drag: false, error: null, isUploading: false, groupType,
			isOpenAreYouSureModal: false, forceCloseDatepicker: false, dateOpen: false,
			clientTarificationsList: [], groupTypeOptions
		}
	}

	componentDidMount() {
		const { type, claimWizardDocType } = this.props
		if (type === 'claim' && claimWizardDocType) {
			this.modalNext()
		}
	}

	// not used should delete
	addFilesToUpload(item) {
		const { type, id, dispatch } = this.props

		dispatch(initAdditionalUpload(type, id, item))
	}

	/**
	 * Close modal an reset the flags
	 */
	closeModal() {
		const { dispatch } = this.props

		this.setState({ isUploading: false })

		// reset the file list to avoid a false enable of upload button
		currentFiles = {}

		dispatch(hideUploadModal())

		this.onSelectDocuments()
	}

	onDragEnter() {
		this.setState({ drag: true })
	}

	onDragLeave() {
		this.setState({ drag: false })
	}

	/**
	 * This function add a file to the upload list.
	 *
	 * There was an insecure solution for generating preview. What is eliminated.
	 * If you put it back to use URL.createObjectURL(file) to generate preview please
	 * use the following code as an event hook in react-dropzone to prevent memory leaks.
	 *        cleanup = {() => {
	 *             // Revoke data uris when done using the previews
	 *             URL.revokeObjectURL(file.preview);
	 *         }}
	 * @param {*} fileType
	 * @param {*} files
	 * @returns
	 */
	async addFiles(files) {
		const { dispatch } = this.props
		let outFiles = []

		for (const file of files) {
			//create a unique identifier
			const fileId = uuidv4()
			let tmp
			const today = moment()
			if (file.tarificationDocId && file.origin === 'DS_ORIGIN_ORACLE') {
				tmp = {
					name: file.tarificationDocType,
					lastModified: today,
					size: '',
					origin: file.origin,
					progress: 0,
					fileId: file.tarificationDocId,
					documentTypeIdx: file.documentTypeIdx,
					documentToLowValue: file.documentToLowValue,
					typeDocument: file.typeDocument
				}
			} else {
				tmp = {
					name: file.name,
					lastModified: today,
					size: file.size,
					//preview: file.preview,
					type: file.type.split("/").splice(-1)[0],
					progress: 0,
					fileId,
				}

				if (tmp.size > 10 * 1024 * 1024) {
					tmp.error = _('too_large_file')

					return false
				}
				if (tmp.size == 0) {
					tmp.error = _('file_is_empty_maybe_compressed')

					return false
				}
			}

			//error is wrong file type
			if (/^(jpe?g|gif|png|pdf|tiff?)$/.test(tmp.type) ||
				(/^(|(x-)?download)$/.test(tmp.type) && /\.(jpe?g|gif|png|pdf|tiff?)$/.test(tmp.name)) ||
				(file.origin === 'DS_ORIGIN_ORACLE')) {
				outFiles = [...outFiles, tmp]
				currentFiles[fileId] = file
			} else {
				tmp.error = _('wrong_file_type')
				outFiles = [...outFiles, tmp]
			}
		}

		await dispatch(addFiles(outFiles))
		//actualize the options list avery time a doc is added
		this.createGroupTypeOptionsList()
		this.setState({ drag: false })
	}

	async modalNext() {
		const groupId = this.state.groupType
		if (groupId) {
			const { dispatch } = this.props
			await dispatch(goToFileForm(groupId))
			this.createGroupTypeOptionsList()
		}
	}
	/**
	 * This kick back the modal
	 */
	modalBack() {
		const { dispatch } = this.props
		return dispatch(goBackToUploadType())
	}

	async modalSave() {
		const { dispatch, disableUploadToOracle } = this.props
		const { uploadComment } = this.refs
		const comment = uploadComment && uploadComment.value

		let result = await dispatch(uploadFiles(comment, currentFiles, disableUploadToOracle))

		// push the uploaded file list for the parent module what is using the uploader
		await this.pushFilesForParentModuleByCallback(result)


		this.setState({ isUploading: true, error: null })
	}

	/**
	 * This function is made to handle callback function if exists by uploaded files when the uploader finished his job.
	 * @param {*} uploadResult
	 */
	async pushFilesForParentModuleByCallback(uploadResult) {
		const { step, done, onSelectDocuments, comment, groupId, uploadInfo } = this.props

		// check if there is a callback to provide the list of uploaded files
		if (step === 2 && done && onSelectDocuments && typeof onSelectDocuments === "function") {
			for (let i = 0; i < uploadResult.length; i++) {
				let oneResult = uploadResult[i]
				// oneResult: {status: ..., value: ...}
				// possible statuses: 'fulfilled', 'rejected'
				if (oneResult.status === "fulfilled") {
					let resultRecord = nesProp.get(oneResult, "value.response.temporaryFileRecord")
					resultRecord['uploadComment'] = comment
					resultRecord['documentUploadGroupTypeId'] = groupId
					// call the callback to provide the uploaded file information for external components
					await onSelectDocuments(resultRecord)
				}
			}
		}
	}

	/**
	 * This function will close the upload popup.
	 */
	cancelUpload() {
		const { dispatch } = this.props
		// reset the file list to avoid a false enable of upload button
		currentFiles = {}

		this.setState({ isUploading: false })

		dispatch(cancelUpload())
	}

	clickDate(ev) {
		// ev.stopPropagation()
		// ev.nativeEvent.stopImmediatePropagation()
		// this.setState({ forceCloseDatepicker: false })
	}

	changeDate(value, file, filetype = null) {
		const { dispatch } = this.props

		dispatch(changeFileDate(value, file, filetype))
	}

	async removeFile(ev, file, fileType = null) {
		ev.stopPropagation()
		ev.nativeEvent.stopImmediatePropagation()
		const { dispatch } = this.props
		delete currentFiles[file.fileId]
		await dispatch(removeFile(file, fileType))
		this.createGroupTypeOptionsList()
	}

	async remFileAllocation(file, filetype) {
		const { dispatch } = this.props
		this.setState({ error: { [filetype]: null } })
		await dispatch(unAllocateFile(file, filetype))
		this.createGroupTypeOptionsList()
	}

	updateFormValue(value, field) {
		const { dispatch } = this.props

		dispatch({
			type: "redux-form/CHANGE",
			field: field.name,
			value: value && value.value || '',
			touch: value && value.touched || field.touched,
			form: "emailSender"
		})

		this.forceUpdate()
	}


	/**
	 * This function set the field value content in store
	 *
	 * @param {*} value
	 */
	onChangeCommentValue(value) {
		const { dispatch } = this.props
		dispatch(updateCommentOnFileUpload(value.target.value))
	}

	onNavigateBack(fileTypes, comment) {
		if (fileTypes.find(i => i.files && i.files.length > 0) || comment) {
			return this.openAreYouSureModal()
		}
		return this.modalBack()
	}

	/**
	 * Open ask modal
	 *
	 * @param {*} e
	 */
	openAreYouSureModal(e) {
		this.setState({ isOpenAreYouSureModal: true })
	}

	/**
	 * Close ask modal
	 */
	closeAreYouSureModal() {
		this.setState({ isOpenAreYouSureModal: false })
	}

	handleScroll(e) {
		const { forceCloseDatepicker } = this.state
		if (!forceCloseDatepicker) {
			this.setState({ forceCloseDatepicker: true })
		}
	}

	/**
	 * Method used in the tarification documents selection modal
	 * @param {*} item
	 * @param {*} tarificationDocuments
	 */
	onSelectedTarificationDocuments = (tarificationDocuments) => {
		this.setState({ isTarificationModalOpen: false, clientTarificationsList: [] })
		this.addFiles(tarificationDocuments)
	}

	async onOpenTarificationModalClick(indexTypes) {
		const { dispatch, clientId } = this.props
		const indexTypesIds = indexTypes.map(oneType => oneType.id)
		try {
			const fetchTarificationsRequest = await dispatch(fetchUploadTarifications(clientId))
			this.setState({
				clientTarificationsList: fetchTarificationsRequest.tarifications,
				isTarificationModalOpen: indexTypesIds
			})

		} catch (error) {
			console.warn(error)
		}
	}

	async onAllocateFileToType(file, value, currentFileType = null) {
		const { dispatch } = this.props
		await dispatch(allocateFiles(value, file))
		if (currentFileType) {
			await this.remFileAllocation(file, currentFileType)
		}
		this.createGroupTypeOptionsList()
	}

	createGroupTypeOptionsList() {
		const { groupId, uploadInfo, isUnfinishedClaim, claimWizardDocType } = this.props
		let actGroup = null
		const groupTypeOptions = []

		if (groupId) {
			actGroup = uploadInfo.filter((item) => (item.id === groupId))[0]
		}
		
		if (actGroup) {
			for (const oneFileType of actGroup.fileTypes) {
				if ((oneFileType.max && oneFileType.max > 0 || ((isUnfinishedClaim || claimWizardDocType) && groupId == '1'))
					&& (!oneFileType.files || oneFileType.files.length < oneFileType.max || ((isUnfinishedClaim || claimWizardDocType) && groupId == '1'))) {
					groupTypeOptions.push({
						label: oneFileType.title[global.lang],
						value: oneFileType.id
					})
				}
			}
		}
		groupTypeOptions.sort((a, b) => {
			const nameA = a.label.toUpperCase(); // Ignore case
			const nameB = b.label.toUpperCase(); // Ignore case

			if (nameA < nameB) {
				return -1;
			}

			if (nameA > nameB) {
				return 1;
			}

			// Names are equal
			return 0;
		});

		this.setState({ groupTypeOptions })
	}


	renderUnallocatedFiles(files) {
		const { step } = this.props
		const { forceCloseDatepicker, groupTypeOptions } = this.state

		const ul = files.map((file, i) => {
			return (
				<div key={`${file.fileId || file.documentId}` + i} className={styles.dropzoneFile}>
					{step === 1 &&
						<div
							onClick={(ev) => this.removeFile(ev, file)}
							className={styles.remove}
						>
							{file.name && <img src={require('resources/cross.svg')} />}
						</div>
					}
					<div className={styles.preview}>
						<div>
							<FileIcon file={file} />
						</div>
					</div>
					{file.name ? (
						<div className={styles.name}>{file.name}</div>
					) : (
						<div className={styles.name}>{file.documentDate}</div>
					)}
					{/* {step === 1 && file.name && !file.error &&
						<div className={styles.date} onClick={(ev) => this.clickDate(ev)} >
							<DatePicker
								forceCloseDatepicker={{
									forceClose: forceCloseDatepicker,
									cb: () => this.setState({ forceCloseDatepicker: false })
								}}
								onChange={(value) => this.changeDate(value, file)}
								value={file.lastModified}
								maxDate={moment().toString()}
							/>
						</div>
					} */}

					{step === 1 && file.name && !file.error &&
						<SelectWrapper
							className={cs(styles.formInput, styles.sizeL)}
							value={file.typeId || ''}
							isClearable
							options={groupTypeOptions}
							placeholder={_('typePlaceholder')}
							onChange={(value) => {
								this.onAllocateFileToType(file, value.value)
							}}
						/>
					}

					{step === 1 && file.error &&
						<div className={styles.progressBarContainer}>
							<FileProgress file={file} />
						</div>
					}
				</div>
			)
		})
		return ul
	}

	/**
	* Used to render the drop zones dynamically in juncture with the new tarification selection modal
	* @param {*} item
	* @param {*} groupId
	* @returns
	*/
	renderDropZone(groupId, actGroup) {
		//the upload group that handles tarification index mapping is 27 (BEWB - 593)
		if (groupId === '27') {
			return (
				<div className={styles.mandateDropZoneWrapper}>
					<div
						style={{ minHeight: 60 }}
						className={styles.dropzone + " " + ((this.state.drag) && styles.drag)}
						onDragEnter={() => this.onDragEnter(null)}
						onDragLeave={() => this.onDragLeave()}
						onDrop={(ev) => this.addFiles(ev)}
						onClick={() => this.onOpenTarificationModalClick(actGroup.fileTypes)}
					// disableClick={this.state.isUploading || (item.files && item.files.length >= item.max)}
					>
						<div className={styles.dropzonePlaceholder}>{_('tarificationSelectorPlaceholder')}</div>
					</div>
					<Dropzone
						style={{ minHeight: 60 }}
						className={styles.dropzone + " " + ((this.state.drag) && styles.drag)}
						onDragEnter={() => this.onDragEnter()}
						onDragLeave={() => this.onDragLeave()}
						onDrop={(ev) => this.addFiles(ev)}
					// disableClick={this.state.isUploading || (item.files && item.files.length >= item.max)}
					>
						<div className={styles.dropzonePlaceholder}>{_('filePlaceholder')}</div>
					</Dropzone>
				</div>
			)
		} else {
			return (
				<Dropzone
					style={{ minHeight: 60 }}
					className={styles.dropzone + " " + ((this.state.drag) && styles.drag)}
					onDragEnter={() => this.onDragEnter()}
					onDragLeave={() => this.onDragLeave()}
					onDrop={(ev) => this.addFiles(ev)}
				// disableClick={this.state.isUploading || (item.files && item.files.length >= item.max)}
				>
					<div className={styles.dropzonePlaceholder}>{_('filePlaceholder')}</div>
				</Dropzone>
			)
		}
	}

	renderListOfAllocatedDocuments(actGroup) {
		const { step, error } = this.props
		const { forceCloseDatepicker, groupTypeOptions } = this.state

		const ul = actGroup.fileTypes.map((oneType, i) => {
			if (oneType && oneType.files && oneType.files.length > 0) {
				return (
					<div key={oneType.id + i}>
						<div className={styles.dropTypeTitle}>
							{oneType.title[global.lang] + ' '}
							<span className={styles.filesCount}>
								{this.state.error && this.state.error[oneType.id] &&
									<span className={styles.uploadError}>{this.state.error[oneType.id]}</span>
								}
								{oneType.max > 0 &&
									<span>{oneType.files ? oneType.files.length : 0}/{oneType.max}</span>
								}
							</span>
						</div>
						{(oneType.files && oneType.files.length > 0) &&
							<div className={styles.dropzoneFiles}>
								{oneType.files.map((file) => (
									<div key={file.fileId || file.documentId} className={styles.dropzoneFile}>
										{step === 1 &&
											<div
												onClick={(ev) => this.removeFile(ev, file, oneType.id)}
												className={styles.remove}
											>
												{file.name && <img src={require('resources/cross.svg')} />}
											</div>
										}
										<div className={styles.preview}>
											<div>
												<FileIcon file={file} />
											</div>
										</div>
										{file.name ? (
											<div className={styles.name}>{file.name}</div>
										) : (
											<div className={styles.name}>{file.documentDate}</div>
										)}

										{step === 1 && file.name && !file.error &&

											<SelectWrapper
												className={cs(styles.formInput, styles.sizeL)}
												value={file.typeId || ''}
												isClearable
												options={groupTypeOptions}
												placeholder={_('typePlaceholder')}
												onChange={(value) => {
													if (value.value === oneType.id) {
														return
													}

													this.onAllocateFileToType(file, value.value, oneType.id
													)
												}}
											/>
										}
										{step === 1 && file.error &&
											<div className={styles.progressBarContainer}>
												<FileProgress file={file} />
											</div>
										}
										{step === 2 && file.name &&
											<div className={styles.progressBarContainer}>
												<FileProgress file={file} />
											</div>
										}
									</div>
								))}
							</div>
						}

					</div>
				)
			}
		})
		return ul
	}


	getIcon() {
		try {
			return require(`resources/images/Ryan-Taylor-Green-Tick.svg`)
		} catch (err) {
			return require(`resources/images/icn-no-result.svg`)
		}
	}

	render() {
		const { type, step, groupId, uploadId, uploadInfo, comment, error, done, id, clientId,
			dispatch, unallocatedFiles, claimWizardDocType } = this.props
		const { groupType, isOpenAreYouSureModal, isTarificationModalOpen, clientTarificationsList } = this.state
		let actGroup = null

		const initialOptions = [{value: '', label: _('selectGroupType')}].concat(uploadInfo.map(({id, title}) => (
			{value: id, label: title[global.lang]}
		)))

		if (groupId) {
			actGroup = uploadInfo.filter((item) => (item.id === groupId))[0]
		}

		let canUpload = true

		if (Object.keys(currentFiles).length === 0) {
			canUpload = false
		}

		if (unallocatedFiles && unallocatedFiles.length > 0) {
			canUpload = false
		}

		if (actGroup) {
			for (const item of actGroup.fileTypes) {
				if (item.min !== 0) {
					if (!item.files || (item.files && item.min > item.files.length)) {
						canUpload = false
					}
				}
			}
		} else {
			canUpload = false
		}

		let canExit = true
		if (actGroup) {
			for (const item of actGroup.fileTypes) {
				if (item.files) {
					for (const file of item.files) {
						if (file.progress < 1) {
							canExit = false
							break
						}
					}
				} else if (item.min > 0) {
					canExit = false
				}
			}
		} else {
			canExit = false
		}
		return (
			<div onWheel={e => this.handleScroll(e)} >
				{step === 0 &&
					<div className={styles.modalHeader}>
						<div className={styles.title}>{_('addDocuments')}</div>

					</div>
				}
				{step >= 1 && <div className={styles.title}>{actGroup.title[global.lang]}</div>}
				<div className={styles.commentWrapper}>
					{step > 0 && (type === 'claim' || type === 'contract' || type === 'tarification') &&
						(!uploadId || (uploadId && !(comment === ''))) &&
						<div className={styles.uploadComment}>
							<div className={styles.uploadCommentTitle}>
								<div dangerouslySetInnerHTML={{ __html: _('comment') }} />
							</div>
							<textarea
								ref="uploadComment"
								disabled={uploadId}
								className={uploadId ? styles.disabled : ''}
								value={String(comment || '')}
								onChange={(value) => {
									this.onChangeCommentValue(value)
								}}
							/>
						</div>
					}
					{step > 0 && (type === 'client') &&
						<div className={styles.uploadComment}>
							<div className={styles.uploadCommentTitle}>
								<div dangerouslySetInnerHTML={{ __html: _('clientComment') }} />
							</div>
						</div>
					}
				</div>

				<div className={styles.contentWrapper}>
					<div className={styles.content}>
						{step === 0 && (
							<SelectWrapper
								value={groupType}
								options={initialOptions}
								onChange={value => {
									this.setState({ groupType: value.value })
								}}
								className={styles.step0Select}
							/>
						)}			
						{step > 0 &&
							<div className={styles.fileForm}>
								<div className={styles.dropZoneContainer}>
									<div
										style={{ minHeight: 60 }}
										className={styles.dropzone}
									// onDragEnter={() => this.onDragEnter()}
									// onDragLeave={() => this.onDragLeave()}
									// onDrop={(ev) => this.addFiles(ev)}
									// // disableClick={this.state.isUploading || (item.files && item.files.length >= item.max)}
									// disableClick={true}
									>
										<div className={styles.documentsContainer}>
											<div className={styles.unprocessedDocumentsWrapper}>
												<div className={styles.dropzoneFiles}>
													{/* list of unprocessed documents */}
													<div className={styles.dropType}>
														{this.renderDropZone(groupId, actGroup)}
													</div>
													{this.renderUnallocatedFiles(unallocatedFiles)}

												</div>
											</div>
											<div>
												{/* list of processed documents */}
												{this.renderListOfAllocatedDocuments(actGroup)}
											</div>
										</div>
										<div className={styles.docTypesContainer}>
											{actGroup.fileTypes.map((oneType, i) => {
												return (
													<div key={`${oneType.id}${i}`} className={styles.dropType}>
														<div className={styles.dropTypeTitle}>
															<span className={styles.filesCount}>

																{this.state.error && this.state.error[oneType.id] &&
																	<span className={styles.uploadError}>{this.state.error[oneType.id]}</span>
																}
																{oneType.max > 0 &&
																	<span
																		className={oneType.min && (!oneType.files || oneType.files.length < oneType.min) ? styles.uploadError : ''}
																	>
																		{oneType.min ?
																			<div>
																				{!oneType.files || oneType.files.length < oneType.min ?
																					<span>
																						{oneType.files ? oneType.files.length : 0}/{oneType.max}
																					</span>
																					:
																					<img src={this.getIcon()} />
																				}
																			</div>
																			:
																			<span>{oneType.files ? oneType.files.length : 0}/{oneType.max}</span>

																		}
																	</span>
																}
															</span>
															<p
																className={oneType.min && (!oneType.files || oneType.files.length < oneType.min) ? styles.uploadError : ''}
															>
																{oneType.title[global.lang]}
															</p>

														</div>
													</div>
												)
											})}
										</div>
									</div>
								</div>
							</div>
						}

					</div>
					<div className={styles.buttons}>
						{(step !== 2 || (step === 2 && error)) && <div onClick={() => this.cancelUpload()} className={styles.cancel}>{_('cancel')}</div>}
						{step === 0 && <div onClick={() => this.modalNext()} className={styles.next + " " + styles.enabled}>{_('next')}</div>}
						{(step === 1 && !(type === 'claim' && claimWizardDocType)) && (
							<div onClick={() => {
								this.onNavigateBack(actGroup.fileTypes, comment)
							}} className={cs(styles.next, styles.enabled)}>
								{_('back')}
							</div>
						)}
						{(step === 1 || (step === 2 && !done)) && !error &&
							<div
								onClick={async () => {
									if (canUpload) {
										this.modalSave()
									}

									return
								}}
								className={styles.next + " " + (canUpload && styles.enabled)}
							>
								{error ? _('retry') : _('save')}
							</div>
						}
						{(step === 2 && done && !error) &&
							<div
								onClick={() => done && this.cancelUpload()}
								className={styles.next + " " + (done && styles.enabled)}
							>
								{_('exit')}
							</div>
						}
						{/*  BEWB - 247  Removed mifid button  from upload modal */}
						{/* {type === 'contract' && canCreateMifid && false &&
                            <MifidButton
                                moduleKeyToSet={DS_MODULE_CLIENT_CONTRACT}
                                clientId={clientId}
                                contractId={id}
                                callBackOnClose={()=>{}}
                                disabled={!id}
                                forceGetClient={true}
                            />
                        } */}
					</div>
				</div>
				<AreYouSureDialog
					modalIsOpen={isOpenAreYouSureModal}
					title={_("areYouSureToGoBackTitle")}
					message={_("areYouSureToGoBackMessage")}
					cancelLabel={_("cancel")}
					confirmationLabel={_("goBack")}
					onCancel={() => {
						this.closeAreYouSureModal()
					}}
					onConfirmation={(toEmailAddress) => {
						return this.modalBack()
							.then(() => {
								this.closeAreYouSureModal()
							})
					}}
				/>
				<TarificationSelectionModal
					modalIsOpen={isTarificationModalOpen}
					onCancel={() => this.setState({ isTarificationModalOpen: false })}
					dispatch={dispatch}
					clientId={clientId}
					method={this.onSelectedTarificationDocuments}
					clientTarificationsList={clientTarificationsList}
				/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/uploader/uploaderModal.jsx